import Button from '../../Button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogDetails,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger
} from '../../dialogs/BaseDialog';

type AlertDialogProps = {
  children: React.ReactNode;
  title?: string;
  description?: string;
  confirmText?: string;
  onConfirm?: () => void;
  renderTrigger?: () => React.ReactNode;
  contentProps?: React.ComponentPropsWithoutRef<typeof DialogContent>;
} & React.ComponentPropsWithoutRef<typeof Dialog>;

export default function AlertDialog({
  children,
  title = 'Alert',
  description,
  confirmText = 'OK',
  renderTrigger,
  onConfirm,
  contentProps,
  ...props
}: AlertDialogProps) {
  return (
    <Dialog {...props}>
      {!!renderTrigger && (
        <DialogTrigger asChild>{renderTrigger()}</DialogTrigger>
      )}
      <DialogContent {...contentProps}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {!!description && (
            <DialogDescription>{description}</DialogDescription>
          )}
        </DialogHeader>
        <DialogDetails>{children}</DialogDetails>
        <DialogFooter>
          {onConfirm ? (
            <Button size="small" onClick={onConfirm} type="submit">
              {confirmText}
            </Button>
          ) : (
            <DialogClose asChild>
              <Button size="small" type="submit">
                {confirmText}
              </Button>
            </DialogClose>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
